import { AxiosError } from "axios";

export enum ViErrorType {
  Warning = "WARNING", //means that the user is shown a warning
  Error = "ERROR", //means that the side effects are stopped, the state is reset and the user is shown an errror
  Silent = "SILENT", //means that the user is not notified but a report is sent to GCP
}

interface ViErrorProperties {
  message?: string;
  payload?: Record<string, string>;
  actionType?: string;
  code?: string;
  report?: boolean;
  type?: ViErrorType;
  caughtError?: Error;
}

export class ViError extends Error {
  name: string = this.constructor.name;
  code: string = this.constructor.name;
  payload?: Record<string, any>;
  actionType?: string;
  report?: boolean = true;
  type?: ViErrorType = ViErrorType.Error;
  caughtError?: any;
  __proto__?: Error;

  constructor(params?: ViErrorProperties | string | AxiosError) {
    super();
    if (params) {
      if (typeof params === "string") this.message = params;
      else if ("isAxiosError" in params) {
        return new ViAxiosError(params);
      } else {
        if (params?.caughtError) this.caughtError = params.caughtError;
        if (params?.report !== undefined) this.report = params.report;
        if (params?.payload) this.payload = params.payload;
        if (params?.message) this.message = params.message;
        if (params?.code) this.code = params.code;
        if (params?.type) this.type = params.type;
      }
    }
  }
}

export class ViAxiosError extends ViError {
  constructor(error: AxiosError) {
    super();
    if (error.response) {
      this.name = "ViServerError";
      this.code = error.response.data.code || error.response.status;
    } else if (error.request) {
      this.name = "ViServerConnectionError";
    }
    this.caughtError = error.toJSON();
    this.message = error.message;
  }
}

export class ViNoImagesActiveError extends ViError {
  type = ViErrorType.Warning;
  report = false;
  constructor() {
    super();
    this.name = this.constructor.name;
  }
}

export class ViIDBReadError extends ViError {
  type = ViErrorType.Silent;
}

export class ViIDBWriteError extends ViError {
  type = ViErrorType.Silent;
}

export class ViAllImagesDeletedError extends ViError {
  report = false;
}

export class ViDuplicateImagesError extends ViError {
  type = ViErrorType.Warning;
  report = false;
}

export class ViUserNotAuthenticatedError extends ViError {}

export class ViUnableToLoadResultsFromStorage extends ViError {
  report = false;
}

export class ViEnvVariableNotSetError extends ViError {
  constructor(envVariableName: string) {
    super();
    this.message = `${this.constructor.name}: ${envVariableName}`;
    this.payload = { envVariableName };
  }
}
